import { isMaybeIncognitoComet } from '#pplx/frontend/apps/ask/comet-shared/cometUtils.js';
import { useResults } from '#pplx/frontend/apps/ask/providers/ResultsContext.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback, useMemo } from 'react';
export const useEntryEvents = () => {
    const { impression, track } = useInstrumentation();
    const isPerplexityBrowser = isMaybeIncognitoComet();
    const { firstResult } = useResults();
    const backend_uuid = firstResult?.backend_uuid;
    const context_uuid = firstResult?.context_uuid;
    const trackEvent = useCallback((name, data) => {
        track({
            event: name,
            data: {
                entryUUID: backend_uuid,
                threadUUID: context_uuid,
                ...data,
                isPerplexityBrowser,
            },
        });
    }, [backend_uuid, context_uuid, isPerplexityBrowser, track]);
    const impressionEvent = useCallback((name, data, key) => {
        impression({
            event: name,
            key,
            data: {
                entryUUID: backend_uuid,
                threadUUID: context_uuid,
                ...data,
                isPerplexityBrowser,
            },
        });
    }, [backend_uuid, context_uuid, impression, isPerplexityBrowser]);
    return useMemo(() => ({ impressionEvent, trackEvent }), [impressionEvent, trackEvent]);
};
//# sourceMappingURL=useEntryEvents.js.map